import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "calendar" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import {Calendar} from '@fullcalendar/core'
import interactionPlugin from '@fullcalendar/interaction'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridWeek from '@fullcalendar/timegrid'
import router from "@/router";

import {onMounted, reactive, UnwrapRef} from "vue";
import {useRoute} from "vue-router";
import {finishTask} from "@/api/home";
import {message, Modal} from "ant-design-vue";
import {getAppointments} from "@/api/appointment";
import {formatDateTime} from "@/components/ts/components";


interface FormItem {
  fromTime: Date | string,
  toTime: Date | string
}



export default /*#__PURE__*/_defineComponent({
  __name: 't43',
  setup(__props) {


const route = useRoute();


let formItem: UnwrapRef<FormItem> = reactive({
  fromTime: '',
  toTime: ''
});


const onDateSelected = (val: any) => {
  formItem.fromTime = val.start;
  formItem.toTime = val.end;
  const title = "预约确认";
  const content = `从: ${formatDateTime(formItem.fromTime)}  到 ${formatDateTime(formItem.toTime)}`;
  showConfirm(title, content);
}

const onEventClicked = (val: any) => {
  console.log(val);
}

const onEventsSet = (val: any) => {
  console.log(val);
}

const showConfirm = (title: any, content: any) => {
  Modal.confirm({
    title: () => title,
    content: () => content,
    onOk() {
      return new Promise((_resolve, _reject) => {
        finishTask43(_resolve,_reject)
      }).catch(() => console.log('Oops errors!'));
    },
    onCancel() {
      message.warn("预约取消")
    },
  });
};

let calendar: any = null;

const calendarOptions: any = {
  plugins: [
    interactionPlugin,
    dayGridPlugin,
    timeGridWeek
  ],
  initialDate: new Date(),
  initialEvents: [],
  validRange: {
    start: new Date()
  },
  events: [],
  contentHeight: 'auto',
  weekNumbers: true,
  slotMinTime: "09:00:00",
  slotMaxTime: "18:00:00",
  initialView: 'timeGridWeek',
  editable: true,
  weekends: true,
  selectable: true,
  select: onDateSelected,
  eventClick: onEventClicked,
  eventsSet: onEventsSet,
}

const getDentistAppointments = (dentistId: any) => {
  getAppointments(dentistId).then((res: any) => {
    res.forEach((x: any) => {
      let item = {title: x.patientName, start: new Date(x.fromTime), end: new Date(x.toTime)};
      calendar.addEvent(item);
    })
  });
}

const finishTask43 = (_resolve:any,_reject:any) => {
  let processDefinitionId = route.query.processDefinitionId;
  let processInstanceId = route.query.processInstanceId;
  let processDefinitionKey = route.query.processDefinitionKey;
  let runTimeTaskId = route.query.runTimeTaskId;
  let taskCode = route.query.taskCode

  let parameters = {
    processDefinitionId: processDefinitionId,
    processInstanceId: processInstanceId,
    processDefinitionKey: processDefinitionKey,
    runTimeTaskId: runTimeTaskId,
    taskCode: taskCode,
    params: {
      productItemId: route.query.productItemId,
      dentistId: route.query.dentistId,
      clinicId: route.query.clinicId,
      patientId: route.query.patientId,
      appointmentId: route.query.appointmentId,
      fromTime: formItem.fromTime,
      toTime: formItem.toTime
    }
  };
  console.log(parameters)
  finishTask(parameters).then(() => {
    message.success("操作成功");
    _resolve();
    router.push({
      path: "/home",
    });
  }).catch(()=>{
    _reject();
  })
}


onMounted(() => {
  const calendarEl: any = document.getElementById('calendar')
  calendar = new Calendar(calendarEl, calendarOptions);
  calendar.render();
  getDentistAppointments(route.query.dentistId)
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})